module.exports = __webpack_public_path__ + "img/pptxIcon.96e7f9e.svg";